import { Flex } from '@/components/ui/lib/flex';
import { Skeleton } from '@/components/ui/lib/skeleton';
import type { SkeletonRowsProps } from '@/types/skeleton-rows';

/** A vertical run of identical placeholder rows — the shape of a list or a table body. */
const SkeletonRows = ({
  count,
  height = '3.25rem',
  rounded = 'xl',
  gap = '3',
}: SkeletonRowsProps) => (
  <Flex direction="column" gap={gap}>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={index} height={height} rounded={rounded} />
    ))}
  </Flex>
);

export default SkeletonRows;
